import lb from '@/lib/loopback';

export function findTiposObjeto(settings = {}) {
  return lb
    .find('/TipoObjetos/', settings);
}

export default {
  findTiposObjeto,
};
